document.addEventListener('DOMContentLoaded',function(){
  var $ = theme.jQuery;
  
  $(document).ready(function() {
    document.addEventListener('triggerUpdateCart', function(evt) {
      $('body').trigger('updateCart', evt.detail);
      $('body').trigger('added.ajaxProduct');
      document.dispatchEvent(new CustomEvent('added:ajaxProduct', {
        detail: evt.detail
      }));
    });
  });

});